export type SessionType =
  | "bienvenida"
  | "panel"
  | "charla"
  | "keynote"
  | "workshop"
  | "speed-dating"
  | "entrevista"
  | "break"
  | "cierre";

export type SessionSpeaker = {
  name: string;
  role?: string;
  institution?: string;
  photo?: string | null;
  time?: string;
  breakAfter?: boolean;
};

export type ScheduleSession = {
  id: string;
  time: string;
  type: SessionType;
  typeLabel: string;
  auditorium?: "Transforma" | "Evoluciona";
  accentColor: string;
  title: string;
  description?: string;
  speakers?: SessionSpeaker[];
  moderator?: string;
  isBreak?: boolean;
};

export type SynchronizedRow = {
  id: string;
  timeRange: string;
  block: "am" | "pm";
  day1Sessions: ScheduleSession[];
  day2Sessions: ScheduleSession[];
  isBreakRow?: boolean;
};

function compactSlot(
  id: string,
  time: string,
  typeLabel: string
): ScheduleSession {
  return {
    id,
    time,
    type: "break",
    typeLabel,
    accentColor: "#555558",
    title: typeLabel,
    isBreak: true,
  };
}

function breakSlot(id: string, time: string): ScheduleSession {
  return compactSlot(id, time, "BREAK");
}

export const synchronizedTimeline: SynchronizedRow[] = [
  {
    id: "time-0830",
    timeRange: "08:30 - 08:50",
    block: "am",
    isBreakRow: true,
    day1Sessions: [
      {
        id: "d1-b0",
        time: "08:30–08:50",
        type: "break",
        typeLabel: "COFFEE BIENVENIDA",
        accentColor: "#555558",
        title: "COFFEE BIENVENIDA",
        isBreak: true,
      },
    ],
    day2Sessions: [
      {
        id: "d2-b0",
        time: "08:30–08:50",
        type: "break",
        typeLabel: "COFFEE BIENVENIDA",
        accentColor: "#555558",
        title: "COFFEE BIENVENIDA",
        isBreak: true,
      },
    ],
  },

  {
    id: "time-0850",
    timeRange: "08:50 - 09:30",
    block: "am",
    day1Sessions: [
      {
        id: "d1-s1",
        time: "08:50–09:30",
        type: "bienvenida",
        typeLabel: "BIENVENIDA",
        auditorium: "Transforma",
        accentColor: "#ED1E79",
        title: "Apertura Impacta IA",
        description:
          "Bienvenida oficial al encuentro de inteligencia artificial aplicada más relevante de Chile.",
        speakers: [
          {
            name: "Francisco Martínez",
            role: "Socio Director",
            institution: "Brinca",
            photo: "/img/speakers/francisco-martinez.webp",
          },
          {
            name: "Julio Pertuzé",
            institution: "FCh",
            photo: "/img/speakers/julio-pertuze.webp",
          },
          {
            name: "Camila Mönckeberg",
            institution: "CORFO",
            photo: null,
          },
        ],
      },
    ],
    day2Sessions: [
      {
        id: "d2-s1",
        time: "08:50–09:30",
        type: "charla",
        typeLabel: "CHARLA",
        auditorium: "Transforma",
        accentColor: "#ED1E79",
        title: "IA como Motor de Productividad e Innovación para Chile",
        description:
          "Oportunidades estratégicas de salto tecnológico y escalamiento industrial mediante IA.",
        speakers: [
          {
            name: "Julio Pertuzé",
            role: "Académico PUC, ex Subsecretario de Economía",
            institution: "FCh",
            photo: "/img/speakers/julio-pertuze.webp",
          },
        ],
      },
    ],
  },

  {
    id: "time-0930",
    timeRange: "09:30 - 10:15",
    block: "am",
    day1Sessions: [
      {
        id: "d1-s2",
        time: "09:30–10:15",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Transforma",
        accentColor: "#6666FF",
        title: "Encuentro público-privado para una adopción sin brechas",
        description:
          "Políticas de innovación, articulación público-privada y estrategia país para el desarrollo y adopción de IA.",
        speakers: [
          {
            name: "Catherine Muñoz",
            institution: "Idónea Consultores",
            photo: null,
            breakAfter: true,
          },
          {
            name: "Fernando Hentzschel",
            role: "Head of Technological Capabilities",
            institution: "CORFO",
            photo: "/img/speakers/fernando-hentzschel.webp",
          },
          {
            name: "George Lever",
            role: "Especialista en economía digital",
            institution: "Cámara de Comercio de Santiago",
            photo: "/img/speakers/george-lever.webp",
          },
        ],
        moderator: "Modera Carolina Garlick, Diario Financiero.",
      },
    ],
    day2Sessions: [breakSlot("d2-b0930", "09:30–10:00")],
  },

  {
    id: "time-1000",
    timeRange: "10:00 - 11:20",
    block: "am",
    day1Sessions: [
      {
        id: "d1-s3",
        time: "10:30–11:20",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Transforma",
        accentColor: "#6666FF",
        title: "Gobernanza Corporativa de la IA",
        description:
          "Políticas, ética, gestión de riesgos y alineamiento de la IA desde la alta dirección y directorios.",
        speakers: [
          {
            name: "Claudia Ramos",
            role: "Gerente de la División de Innovación y Data & Analytics",
            institution: "Banco Bci",
            photo: "/img/speakers/claudia-ramos.webp",
          },
          {
            name: "Macarena McKay",
            role: "Directora Ejecutiva",
            institution: "PUC",
            photo: "/img/speakers/macarena-mckay.webp",
            breakAfter: true,
          },
          {
            name: "Felipe Morales",
            role: "VP Omni Supply Chain",
            institution: "Walmart",
            photo: null,
          },
          {
            name: "Nicolás Rivas",
            role: "Gerente de Soluciones IA",
            institution: "Brinca",
            photo: "/img/speakers/nicolas-rivas.webp",
          },
        ],
        moderator: "Modera José Manuel Morales, Brinca.",
      },
    ],
    day2Sessions: [
      {
        id: "d2-s2a",
        time: "10:00–10:50",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Transforma",
        accentColor: "#6666FF",
        title:
          "La revolución del vibe coding al interior de las empresas: nuevos paradigmas",
        description:
          "Arquitecturas en la nube, agentes autónomos y evolución de plataformas empresariales.",
        speakers: [
          {
            name: "Carlos Araya",
            role: "CFO/CTO",
            institution: "ANASAC",
            photo: "/img/speakers/carlos-araya.webp",
          },
          {
            name: "Nicolás Rivas",
            role: "Gerente de Soluciones IA",
            institution: "Brinca",
            photo: "/img/speakers/nicolas-rivas.webp",
            breakAfter: true,
          },
          {
            name: "Angel Izurieta",
            role: "VP Huawei Cloud para Latinoamérica",
            institution: "Huawei Cloud",
            photo: "/img/speakers/angel-izurieta.webp",
          },
        ],
        moderator: "Modera Marcos Thomas, Tesserix Capital.",
      },
      {
        id: "d2-s2b",
        time: "10:00–11:00",
        type: "charla",
        typeLabel: "CHARLA",
        auditorium: "Evoluciona",
        accentColor: "#ED1E79",
        title: "Historias de adopción: casos sectoriales de transformación",
        description:
          "Empresas líderes compartiendo desafíos y resultados medibles en la implementación de IA.",
        speakers: [
          {
            name: "Andrés Kipreos",
            institution: "BUK",
            time: "10:00",
            photo: null,
          },
          {
            name: "Mariana Hvarneg",
            institution: "Simpletech",
            time: "10:15",
            photo: null,
          },
          {
            name: "Benjamín Frascaroli",
            institution: "Vambe",
            time: "10:30",
            photo: null,
          },
        ],
      },
    ],
  },

  {
    id: "time-1120-break",
    timeRange: "11:20 - 11:45",
    block: "am",
    isBreakRow: true,
    day1Sessions: [breakSlot("d1-b1120", "11:20–11:45")],
    day2Sessions: [],
  },

  {
    id: "time-1115",
    timeRange: "11:15 - 12:15",
    block: "am",
    day1Sessions: [
      {
        id: "d1-s4",
        time: "11:45–12:05",
        type: "charla",
        typeLabel: "CHARLA",
        auditorium: "Transforma",
        accentColor: "#ED1E79",
        title: "El ROI real de la IA: impacto en la rentabilidad del negocio",
        description:
          "Cómo medir el retorno de inversión, priorizar casos de uso viables y evitar iniciativas fragmentadas.",
        speakers: [
          {
            name: "Edmundo Casas",
            role: "Cofundador & CEO",
            institution: "Kauel",
            photo: "/img/speakers/edmundo-casas.webp",
          },
        ],
      },
    ],
    day2Sessions: [
      {
        id: "d2-s3a",
        time: "11:15–12:10",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Transforma",
        accentColor: "#6666FF",
        title: "Desafíos y tensiones de la regulación en IA",
        description:
          "Marco legal, soberanía de datos, protección de privacidad y balance con innovación.",
        speakers: [
          {
            name: "Pedro Huichalaf",
            role: "Abogado y consultor · Ex Subtel",
            institution: "Abogado y Académico",
            photo: "/img/speakers/pedro-huichalaf.webp",
          },
          {
            name: "José Rafael Correa",
            role: "Vicerrector de Tecnologías de la Información",
            institution: "UChile",
            photo: "/img/speakers/jose-rafael-correa.webp",
            breakAfter: true,
          },
          {
            name: "Kenneth Pugh",
            role: "Ex Senador",
            institution: "Ex Senador",
            photo: null,
          },
        ],
        moderator: "Modera Ricardo Lillo, UAI.",
      },
      {
        id: "d2-s3b",
        time: "11:15–12:15",
        type: "workshop",
        typeLabel: "TALLER",
        auditorium: "Evoluciona",
        accentColor: "#9FE870",
        title: "Encuentra tus 3 oportunidades de negocio en 50 minutos",
        description:
          "La mayoría de las empresas ya usa IA. Pocas capturan valor real. En esta sesión ejecutiva no hablamos de tecnología: identificamos oportunidades concretas para su negocio.",
        speakers: [
          {
            name: "Softtek",
            role: "Facilitadores de Innovación y Desarrollo Asistido",
            institution: "Softtek",
            photo: "/img/partners/softtek-logo.png",
          },
        ],
      },
    ],
  },

  {
    id: "time-1205-break",
    timeRange: "12:05 - 12:35",
    block: "am",
    isBreakRow: true,
    day1Sessions: [breakSlot("d1-b1205", "12:05–12:35")],
    day2Sessions: [breakSlot("d2-b1210", "12:10–12:35")],
  },

  {
    id: "time-1235",
    timeRange: "12:35 - 13:25",
    block: "am",
    day1Sessions: [
      {
        id: "d1-s5",
        time: "12:35–13:25",
        type: "keynote",
        typeLabel: "KEYNOTE",
        auditorium: "Transforma",
        accentColor: "#1DD2B3",
        title:
          "Against Productivity: Reaping the rewards of the AI revolution",
        description:
          "Visión global sobre ciencia del comportamiento, productividad corporativa y el impacto de la IA generativa.",
        speakers: [
          {
            name: "Stefano Puntoni",
            role: "Experto global en IA y ciencia del comportamiento",
            institution: "Wharton",
            photo: "/img/speakers/speaker-1.webp",
          },
        ],
      },
    ],
    day2Sessions: [
      {
        id: "d2-s4a",
        time: "12:35–13:25",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Transforma",
        accentColor: "#6666FF",
        title: "IA Industrial, gemelos digitales y logística",
        description:
          "Eficiencia operativa, mantenimiento predictivo y modelamiento digital en grandes operaciones.",
        speakers: [
          {
            name: "Matías Jory",
            role: "Director for Industrial Competitiveness",
            institution: "CMPC",
            photo: "/img/speakers/matias-jory.webp",
          },
          {
            name: "Nicolás Tagle",
            role: "Gerente de Innovación y Tecnología",
            institution: "Minera Los Pelambres",
            photo: null,
            breakAfter: true,
          },
          {
            name: "Marcos Orchard",
            role: "Profesor de Ingeniería Eléctrica",
            institution: "U. de Chile",
            photo: "/img/speakers/marcos-orchard.webp",
          },
        ],
        moderator: "Modera Julio Riutort, UAI.",
      },
      {
        id: "d2-s4b",
        time: "12:35–13:25",
        type: "workshop",
        typeLabel: "DEMODAY",
        auditorium: "Evoluciona",
        accentColor: "#9FE870",
        title: "8 startups, 4 minutos para descubrir nuevas oportunidades",
        description:
          "Grandes corporativos presentan sus desafíos reales de IA ante startups especializadas.",
        speakers: [
          {
            name: "FCh & Startups",
            institution: "FCh & Startups",
            photo: null,
          },
        ],
      },
    ],
  },

  {
    id: "time-1325-break",
    timeRange: "13:25 - 14:30",
    block: "pm",
    isBreakRow: true,
    day1Sessions: [compactSlot("d1-almuerzo", "13:25–14:30", "ALMUERZO")],
    day2Sessions: [
      {
        id: "d2-almuerzo",
        time: "13:25–14:25",
        type: "break",
        typeLabel: "LUNCH BREAK",
        accentColor: "#555558",
        title: "Open mic sponsors y soluciones",
        description: "Open mic sponsors y soluciones · Presentaciones 3 min c/u.",
        isBreak: true,
      },
    ],
  },

  {
    id: "time-1430",
    timeRange: "14:25 - 15:20",
    block: "pm",
    day1Sessions: [
      {
        id: "d1-s6a",
        time: "14:30–15:20",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Transforma",
        accentColor: "#6666FF",
        title:
          "El Futuro del Trabajo con IA, Impacto en Personas y Gestión del Cambio",
        description:
          "Inteligencia Aumentada, desarrollo de nuevas capacidades en equipos y liderazgo en la transición.",
        speakers: [
          {
            name: "Paula Aguirre",
            role: "Vicerrectora de Inteligencia Digital",
            institution: "PUC",
            photo: "/img/speakers/paula-aguirre.webp",
          },
          {
            name: "Denisse Goldfarb",
            role: "CEO The People Future · Ex CPO Walmart y Microsoft",
            institution: "The People Future",
            photo: "/img/speakers/new-denisse-goldfarb.webp",
            breakAfter: true,
          },
          {
            name: "Francisco Martínez",
            role: "Gerente de Estrategia, Innovación y Cultura",
            institution: "Brinca",
            photo: "/img/speakers/francisco-martinez.webp",
          },
        ],
        moderator: "Modera Patricio Millar, Mentor.",
      },
      {
        id: "d1-s6b",
        time: "14:30–15:10",
        type: "charla",
        typeLabel: "CHARLA",
        auditorium: "Evoluciona",
        accentColor: "#ED1E79",
        title: "Líderes Habilitadores del Cambio",
        description:
          "Casos prácticos sobre adopción de IA, cambio cultural y competencias directivas.",
        speakers: [
          {
            name: "Claudia Montoya",
            role: "Directora de Empresas & Mentora Directiva",
            institution: "REDMAD",
            time: "14:30",
            photo: "/img/speakers/claudia-montoya.webp",
          },
          {
            name: "Natalia Lidijover",
            role: "Directora",
            institution: "OTIC Sofofa",
            time: "14:50",
            photo: null,
          },
        ],
      },
    ],
    day2Sessions: [
      {
        id: "d2-s5a",
        time: "14:25–15:15",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Transforma",
        accentColor: "#6666FF",
        title: "Datacenters e IA: ¿una oportunidad para Chile?",
        description:
          "Infraestructura crítica, demanda energética, atracción de inversiones y soberanía computacional.",
        speakers: [
          {
            name: "Ignacio Briones",
            role: "Economista y Académico",
            institution: "Economista y Académico",
            photo: "/img/speakers/ignacio-briones.webp",
          },
          {
            name: "Rodrigo Durán",
            role: "Gerente Ejecutivo",
            institution: "CENIA",
            photo: null,
          },
          {
            name: "Cristian López",
            institution: "Google Cloud",
            photo: null,
          },
        ],
        moderator: "Modera Pablo Correa, Brinca.",
      },
      {
        id: "d2-s5b",
        time: "14:25–15:15",
        type: "workshop",
        typeLabel: "SPEED DATING",
        auditorium: "Evoluciona",
        accentColor: "#9FE870",
        title: "Conecta directamente tus desafíos con soluciones de startups",
        description:
          "Ronda intensiva de reuniones 1 a 1 entre ejecutivos corporativos y fundadores de soluciones IA.",
        speakers: [
          {
            name: "FCh & Startups",
            institution: "FCh & Startups",
            photo: null,
          },
        ],
      },
    ],
  },

  {
    id: "time-1520-break",
    timeRange: "15:15 - 15:40",
    block: "pm",
    isBreakRow: true,
    day1Sessions: [breakSlot("d1-b1520", "15:20–15:40")],
    day2Sessions: [breakSlot("d2-b1515", "15:15–15:40")],
  },

  {
    id: "time-1540",
    timeRange: "15:40 - 16:25",
    block: "pm",
    day1Sessions: [
      {
        id: "d1-s7",
        time: "15:40–16:25",
        type: "keynote",
        typeLabel: "KEYNOTE",
        auditorium: "Transforma",
        accentColor: "#1DD2B3",
        title:
          "The Quiet Reckoning for Leaders: What Remains When AI Peels Back the Rest",
        description:
          "Qué habilidades, juicios y roles humanos permanecen irremplazables ante la automatización avanzada.",
        speakers: [
          {
            name: "Daniel Strode",
            role: "Experto en IA y futuro del trabajo; profesor",
            institution: "Duke University",
            photo: "/img/speakers/speaker-2.webp",
          },
        ],
      },
    ],
    day2Sessions: [
      {
        id: "d2-s6a",
        time: "15:40–16:25",
        type: "entrevista",
        typeLabel: "ENTREVISTA",
        auditorium: "Transforma",
        accentColor: "#ED1E79",
        title: "La mente humana en la era de la IA",
        description:
          "Exploración interdisciplinaria sobre cognición, conciencia y el futuro de la mente.",
        speakers: [
          {
            name: "Álvaro Fischer",
            role: "Autor",
            institution: "Resiter - Autor",
            photo: null,
          },
        ],
        moderator: "Modera José Manuel Morales, Brinca.",
      },
      {
        id: "d2-s6b",
        time: "15:40–16:25",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Evoluciona",
        accentColor: "#6666FF",
        title: "Rediseño de procesos en CX con IA",
        description:
          "Integración de IA en la experiencia de clientes, omnicanalidad y medición de impacto.",
        speakers: [
          {
            name: "Macarena Catalán",
            role: "Digital Products & UX y Jefa de Salud Digital",
            institution: "BUPA",
            photo: "/img/speakers/macarena-catalan.webp",
          },
          {
            name: "Paz Obrecht",
            institution: "Entel",
            photo: null,
            breakAfter: true,
          },
          {
            name: "Cristian Ludwig",
            role: "Gerente de Inteligencia Artificial",
            institution: "BCI",
            photo: "/img/speakers/christian-ludwig.webp",
          },
        ],
        moderator: "Modera Marisa Cozak, Asociación DEC Chile.",
      },
    ],
  },

  {
    id: "time-1640",
    timeRange: "16:30 - 17:30",
    block: "pm",
    day1Sessions: [
      {
        id: "d1-s8a",
        time: "16:40–17:30",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Transforma",
        accentColor: "#6666FF",
        title:
          "Sociedad del futuro: de la escasez a la abundancia — trabajo, riqueza y sociedad en la era de la IA",
        description:
          "Perspectivas macroeconómicas sobre productividad nacional y transformación estructural.",
        speakers: [
          {
            name: "Alfredo Persico",
            role: "CEO Futurelab",
            institution: "CEO Futurelab",
            photo: "/img/speakers/alfredo-persico.webp",
          },
          {
            name: "Alberto Mayol",
            role: "Sociólogo, Escritor y Analista Político-Social",
            institution: "Analista Político-Social",
            photo: "/img/speakers/alberto-mayol.webp",
          },
          {
            name: "Raphael Bergoeing",
            role: "Economista y profesor Escuela de Negocios",
            institution: "UAI",
            photo: "/img/speakers/raphael-bergoeing.webp",
          },
        ],
        moderator: "Modera Eduardo Gomien, FCh.",
      },
      {
        id: "d1-s8b",
        time: "16:40–17:20",
        type: "charla",
        typeLabel: "CHARLA",
        auditorium: "Evoluciona",
        accentColor: "#ED1E79",
        title: "Herramientas Habilitadoras para la Transformación",
        description:
          "Estrategias de desarrollo de capacidades digitales, formación continua y herramientas.",
        speakers: [
          {
            name: "Oscar Vidal",
            role: "Líder Académico y de Calidad",
            institution: "FCh",
            time: "16:40",
            photo: "/img/speakers/oscar-vidal.webp",
          },
          {
            name: "Andrés Blake",
            role: "CEO UPSKILL OTEC y Director de Proyectos",
            institution: "OTEC Upskill",
            time: "17:00",
            photo: "/img/speakers/andres-blake.webp",
          },
        ],
      },
    ],
    day2Sessions: [
      {
        id: "d2-s7",
        time: "16:30–17:20",
        type: "panel",
        typeLabel: "PANEL",
        auditorium: "Transforma",
        accentColor: "#6666FF",
        title: "Ley I+D, oportunidades para la IA",
        description:
          "Incentivos tributarios, financiamiento para proyectos científico-tecnológicos y fomento a la innovación.",
        speakers: [
          {
            name: "Jocelyn Olavarría",
            institution: "CORFO",
            photo: null,
          },
          {
            name: "Juviska Meza",
            institution: "Brinca",
            photo: null,
          },
          {
            name: "Richard Weber",
            institution: "Universidad de Chile",
            photo: null,
          },
        ],
        moderator: "Modera Andrés Blake, Upskill.",
      },
    ],
  },

  {
    id: "time-cierre",
    timeRange: "17:20 - 17:30",
    block: "pm",
    day1Sessions: [
      {
        id: "d1-s9",
        time: "17:30",
        type: "cierre",
        typeLabel: "CIERRE DÍA 1",
        auditorium: "Transforma",
        accentColor: "#ED1E79",
        title: "Cierre Día 1",
        speakers: [
          {
            name: "Sebastián Acevedo",
            institution: "Fundación Chile",
            photo: "/img/speakers/sebastian-acevedo.webp",
          },
          {
            name: "Francisco Martínez",
            institution: "Brinca",
            photo: "/img/speakers/francisco-martinez.webp",
          },
        ],
      },
    ],
    day2Sessions: [
      {
        id: "d2-s8",
        time: "17:20",
        type: "break",
        typeLabel: "CIERRE",
        accentColor: "#555558",
        title: "CIERRE",
        isBreak: true,
      },
    ],
  },
];
